/**
 * Breakpoint Tokens - Responsive design breakpoints
 */

export const breakpoints = {
  xs: '360px',
  sm: '768px',
  md: '1024px',
  lg: '1440px',
  xl: '1600px',
  '2xl': '1920px',
};
